/* 
  命题教师聘用
*/
import request from "@/utils/request";

//获取命题教师聘用页面参数
export function getParam() {
  return request({
    url: "/propositionteacher/propositionTchEmploy/getParam",
    method: "get"
  });
}

//获取命题教师聘用分页列表
export function getPropositionTchEmploy(params) {
  return request({
    url: "/propositionteacher/propositionTchEmploy/getPropositionTchEmploy",
    method: "get",
    params
  });
}

//打印聘书
export function printOffer(data) {
  return request({
    // url: window.config.baseUrl4Print+  "/propositionteacher/propositionTchEmploy/printOffer",
    url: window.config.baseUrl4Shool+  "/propositionteacher/propositionTchEmploy/printOffer",
    method: "post",
    responseType:"blob",
    data
  });
}

//发送短信息
export function sendMessagePropositionTeacherEmploy(data) {
  return request({
    url: "/propositionteacher/propositionTchEmploy/sendMessage",
    method: "post",
    data
  });
}

// 获取短信教师名单
export function getMsgTeacher(params: Object) {
  return request({
    url: "/propositionteacher/propositionTchEmploy/getMsgTeacher",
    method: "get",
    params
  });
}

// 删除信息
export function deleteInfo(data) {
  return request({
    url: "/propositionteacher/propositionTchEmploy/deleteInfo",
    method: "post",
    data
  });
}
